import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dc78500"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FileReader__wrap" }
const _hoisted_2 = ["disabled", "accept", "multiple"]
const _hoisted_3 = {
  key: 0,
  class: "FileReader__error"
}
const _hoisted_4 = {
  key: 1,
  class: "FileReader__list"
}
const _hoisted_5 = { class: "item__name" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "fas fa-spinner ml-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["FileReader", { 'FileReader--notempty': _ctx.value.length > 0, invalid: _ctx.isInvalid }]),
      tabindex: "0"
    }, [
      _createElementVNode("input", {
        type: "file",
        hidden: "",
        disabled: _ctx.disabled,
        accept: _ctx.accept,
        multiple: _ctx.multiple,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)))
      }, null, 40, _hoisted_2),
      (_ctx.placeholder)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["FileReader__placeholder", { selected: _ctx.value.length > 0 }])
          }, _toDisplayString(_ctx.computedPlaceholder), 3))
        : _createCommentVNode("", true),
      (!_ctx.disabled && _ctx.value.length > 0)
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: "FileReader__reset fas fa-times",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetFiles && _ctx.resetFiles(...args)), ["prevent"]))
          }))
        : _createCommentVNode("", true)
    ], 2),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true),
    (_ctx.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (file, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "list__item",
              key: file
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(file.name), 1),
              (!_ctx.disabled && !_ctx.loading)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "item__remove fas fa-times ml-3",
                    onClick: ($event: any) => (_ctx.removeFile(i))
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}